/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilePlay: {
  name: 'file-play';
  data: string;
} = {
  name: 'file-play',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 1 2-2h6.586a2 2 0 0 1 .242.015 1.006 1.006 0 0 1 .99.41c.064.05.124.103.182.16L19.414 8c.058.058.112.118.161.182a.999.999 0 0 1 .41.99c.01.08.015.16.015.242V14a1 1 0 1 1-2 0v-4h-4a2 2 0 0 1-2-2V4H6v10a1 1 0 1 1-2 0V4Zm10 4V5.414L16.586 8H14Zm-4.606 6.08A1 1 0 0 0 8 15v6a1 1 0 0 0 1.394.92l7-3a1 1 0 0 0 0-1.84l-7-3ZM13.46 18 10 19.483v-2.966L13.461 18Z" fill="currentColor"/></svg>`,
};
